/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Free_NameInputs */

const en_pricing_free_name = /** @type {(inputs: Pricing_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base Operator`)
};

const es_pricing_free_name = /** @type {(inputs: Pricing_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const fr_pricing_free_name = /** @type {(inputs: Pricing_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit`)
};

const de_pricing_free_name = /** @type {(inputs: Pricing_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos`)
};

const ja_pricing_free_name = /** @type {(inputs: Pricing_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料`)
};

const zh_pricing_free_name = /** @type {(inputs: Pricing_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费版`)
};

const ar_pricing_free_name = /** @type {(inputs: Pricing_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجاني`)
};

const id_pricing_free_name = /** @type {(inputs: Pricing_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operator Dasar`)
};

const it_pricing_free_name = /** @type {(inputs: Pricing_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const ru_pricing_free_name = /** @type {(inputs: Pricing_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатный`)
};

const pt_pricing_free_name = /** @type {(inputs: Pricing_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grátis`)
};

const ko_pricing_free_name = /** @type {(inputs: Pricing_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료`)
};

/**
* | output |
* | --- |
* | "Base Operator" |
*
* @param {Pricing_Free_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_free_name = /** @type {((inputs?: Pricing_Free_NameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Free_NameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_free_name(inputs)
	if (locale === "es") return es_pricing_free_name(inputs)
	if (locale === "fr") return fr_pricing_free_name(inputs)
	if (locale === "de") return de_pricing_free_name(inputs)
	if (locale === "ja") return ja_pricing_free_name(inputs)
	if (locale === "zh") return zh_pricing_free_name(inputs)
	if (locale === "ar") return ar_pricing_free_name(inputs)
	if (locale === "id") return id_pricing_free_name(inputs)
	if (locale === "it") return it_pricing_free_name(inputs)
	if (locale === "ru") return ru_pricing_free_name(inputs)
	if (locale === "pt") return pt_pricing_free_name(inputs)
	return ko_pricing_free_name(inputs)
});